import { NoteDashboard, NotePost } from '@deliveries-app/models';
import api from '../../api';

/**
 * Add Notes Based on Date Dashboard
 *
 * @param {number} branch_id
 * @param {NotePost} param
 *
 * @returns {Promise<{data: NoteDashboard}>}
 */
export async function addNoteToDashboard(
  branch_id: number,
  param: NotePost
): Promise<NoteDashboard> {
  try {
    const res = await api.post<{ data: NoteDashboard }>(
      `/api/v1/branches/${branch_id}/notes/create`,
      {
        date: param.date,
        description: param.description,
      }
    );
    return res.data.data;
  } catch (err) {
    console.log('Post Notes error', err);
    throw err;
  }
}

/**
 * Get Notes Based on Date Dashboard
 *
 * @param {number} branch_id
 * @param {date} string
 *
 * @returns {Promise<{data: NoteDashboard}>}
 */
export async function getNoteToDashboard(
  branch_id: number,
  date: string
): Promise<NoteDashboard> {
  try {
    const res = await api.get<{ data: NoteDashboard }>(
      `/api/v1/branches/${branch_id}/notes?date=${date}`
    );

    return res.data.data;
  } catch (err) {
    console.log('Get Note Error', err);
    throw err;
  }
}

export const noteServices = {
  addNoteToDashboard,
  getNoteToDashboard,
};
